import "./Turnstile.css";

export default function Turnstile() {
	return (
		<div id="turnstile-container">
			<div id="turnstile"></div>
		</div>
	);
}
